import { render, staticRenderFns } from "./ResourceHide.vue?vue&type=template&id=5b4fb83d"
import script from "./ResourceHide.vue?vue&type=script&lang=js"
export * from "./ResourceHide.vue?vue&type=script&lang=js"
import style0 from "./ResourceHide.vue?vue&type=style&index=0&id=5b4fb83d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports